var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h6',[_vm._v(" Tag "+_vm._s(_vm.todayWorkingday)+" von "+_vm._s(_vm.detectedBussinessdays))])])
}
var staticRenderFns = []

export { render, staticRenderFns }